export default "__VITE_ASSET__Do6bzb1$__"